<template>
  <div class="aiChatList">
    <div v-if="!lo && !Kayit" class="aiChatKayit">

      <h5>Chat Kullanım Bilgilendirmesi</h5>
      <ol>
        <li>Aynı şirketten kullanıcılar ile sınırsız mesajlaşabilirsiniz.</li>
        <li>Chat veya borçlandırma uyarı geldiğinde mesaj sesi iletilir.
          <br><a @click="OrnekMesaj" class="text-primary"><i class="el-icon-video-play"></i> Örnek Bildirim Sesi</a>
        </li>
        <li>Chatta yazılan bütün mesajlar yazarı tarafından sorumludur.</li>
        <li>Diğer şirket kullanıcıları ile chat yapmak için kayıt sonrası izin verebilirsiniz.</li>
        <li>Yazdığınız hiç bir mesajlaşma silinemeyecektir.</li>
        <li>Karşı tarafın yazdığı bütün mesajlardan muhatapı sorumludur Aidatım sorumlu değildir.</li>
        <li>Chat sistemi sadece şirketler tarafından kullanılmaktadır.</li>
      </ol>

      <el-button @click="KayitOl" type="success" class="btn-block">Kabul et ve Kayıt Ol</el-button>
    </div>
    <div v-if="!lo && Kayit">
      <ul>
        <li @click="Detay('Yapifen')">
          <span class="aiBaslik">{{ Yapifen }}</span>
          <span class="aiIsim">
          Yapıfen Enerji
          <small>Yapıfen Enerji borçlandırma bildirimleri</small>

        </span>

        </li>
      </ul>
      <p class="Oncelik">Şirket Kullanıcıları</p>
      <el-alert type="success"
                class="text-center"
                :closable="false" v-if="!Kullanici">Şirket içi chat özelliği için,ekip arkadaşlarınızdan Chat'a
        kaydolmasını
        isteyebilirsiniz.
      </el-alert>
      <ul v-if="Kullanici">
        <li v-for="k in Kullanici" @click="Detay(k)">
        <span class="aiIsim aiIsimoncelik">
          <i v-if="k.om" class="el-icon-s-comment aiOm"></i>
          {{ k.Kullanici }}
          <span class="SonGorulme" v-if="k.sg"><i class="el-icon-time"></i> {{ k.sg }}</span>
        </span>

        </li>

      </ul>
      <p class="Oncelik">
        <el-checkbox label="Aidatım Şirket Kullanıcıları" @change="fGlobal" v-model="Global" name="type"></el-checkbox>
        <el-tooltip class="item" effect="dark"
                    content="Sadece izin veren kullanıcıları görüntüleyebilirsiniz."
                    placement="top">
          <i class="el-icon-info cursor-pointer"></i>
        </el-tooltip>
      </p>
      <ul v-if="Global">
        <li v-for="s in Sirket" @click="Detay(s)">
          <span class="aiBaslik" :class="s.om?'aiOmg':''">
            <b v-if="!s.om">{{ s.Kullanici[0] }}</b>
             <i v-if="s.om" class="el-icon-s-comment"></i>
          </span>
          <span class="aiIsim">
            <span>{{ s.Kullanici }}</span>
            <small>{{ s.Sirket }}</small>
        </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['Yapifen'],
  data() {
    return {
      lo: true,
      Kayit: false,
      Kullanici: null,
      Sirket: null,
      Start: true,
      Global: true,
    }
  },
  methods: {
    OrnekMesaj() {
      new Audio('https://cdn.mudu.pro/Design/sound/msn.mp3').play();
    },
    fGlobal() {
      this.$store.dispatch("Post", {Global: this.Global, path: '_chat/global'})
          .then(response => {
            this.lo = false;
            this.$message.success(response.Mesaj)
          })
    },
    Detay(id) {
      this.$emit('ChatDetay', id)
    },
    KayitOl() {
      this.$store.dispatch("Get", {path: '_chat/kayit'})
          .then(response => {
            this.lo = false;
            if (response.Durum == "OK") {
              this.SayfaYukle();
              this.$message.success(response.Mesaj)
            } else {
              this.$message.error(response.Mesaj)
            }
          })
    },
    SayfaYukle() {
      this.$store.dispatch("Get", {path: '_chat/liste'})
          .then(response => {
            this.lo = false;
            if (response.Durum == "OK") {
              this.Kullanici = response.Kullanici
              this.Sirket = response.Sirket
              this.Kayit = true
              this.Global = response.Global
              setTimeout(() => {
                if (this.Start) this.SayfaYukle();
              }, 10000);
            } else {
              this.Kayit = false
            }
          })
    }
  },
  created() {
    this.SayfaYukle();
  },
  destroyed() {
    this.Start = false;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Chat/ChatListe.vue